import Vue from 'vue'

const DETAIL = {
	LIST: filter => {
		return Vue.$api.get('/details', { params: { filter: filter } })
	},
	BY_ID: id => {
		return Vue.$api.get('/details/' + id)
	},
	CREATE: profile => {
		return Vue.$api.post('/details', profile)
	},
	UPDATE: profile => {
		return Vue.$api.patch('/details/' + profile.id, profile)
	},
	DELETE: id => {
		return Vue.$api.delete('/details/' + id)
	},
	ACTIVITY: id => {
		return Vue.$api.get('/details/' + id + '/activity')
	},
}

export default DETAIL
